import { Card, Row } from "antd";
import React, { useState } from "react";
import Heading from "../../../component/common/Heading";
import CRUDComponent from "../../../component/common/CRUD-Component";
import CONSTANTS from "../../../util/constant/CONSTANTS";
import { PERMISSION } from "../../../util/functions";

const Advertisement = ({ admindetails, permissionId }) => {
  const [extraQuery, setExtraQuery] = useState({ sort: "ranking" });
  const accessPermission = +admindetails?.access
    ?.split(",")
    ?.filter((ele) => ele.includes(permissionId))[0]
    ?.split("-")[1];
  return (
    <>
      <div>
        <Card className="my-5">
          <Heading>Advertisement List</Heading>
          <Row>
            <CRUDComponent
              title="Advertisement"
              // exportData={brandExportData}
              // accessPermission={accessPermission}
              GET={{
                API: CONSTANTS.API.Ad.getAll,
                extraQuery,
                DataModifier: (res, API, Setrefresh) => {
                  return res?.map((data) => {
                    return {
                      ...data,
                      ranking: {
                        data: data?.ranking,
                        onBlur: (Rank) => {
                          if (!isNaN(Number(Rank))) {
                            const UpdateAPIEnd = {
                              ...CONSTANTS?.API.Ad.update,
                            };
                            UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${data?.id}`;
                            API.sendRequest(
                              UpdateAPIEnd,
                              () => {
                                Setrefresh((prev) => !prev);
                              },
                              { ranking: Number(Rank) },
                              `Ranking Update Successfully`
                            );
                          }
                        },
                      },
                      rankingNumber: data?.ranking,
                      isBlocked: {
                        checked: !data?.isBlocked,
                        id: data?.id,
                        isDisable: PERMISSION[accessPermission] === "READ",
                        onClick: (id, val) => {
                          const UpdateAPIEnd = {
                            ...CONSTANTS?.API.Ad.update,
                          };
                          UpdateAPIEnd.endpoint = `${UpdateAPIEnd?.endpoint}${id}`;
                          API.sendRequest(
                            UpdateAPIEnd,
                            () => {
                              Setrefresh((prev) => !prev);
                            },
                            { isBlocked: val },
                            `Advertisement ${
                              val ? "Blocked" : "Unblock"
                            } Successfully`
                          );
                        },
                      },
                    };
                  });
                },
                column: CONSTANTS.TABLE.AD,
              }}
              // isSearch
              DELETE={{
                API: CONSTANTS.API.Ad.delete,
                message: "Deleted Advertisement Successfully",
              }}
              UPDATE={{
                API: CONSTANTS.API.Ad.update,
                isFormData: true,
                message: "Edit Ad successfully",
                modaltitle: "Edit Advertisement",
                modalFields: CONSTANTS.FORM_FIELD.AD_EDIT_MODAL,
                // payloadModifier: (res) => res,
              }}
              CREATE={{
                API: CONSTANTS.API.Ad.add,
                isFormData: true,
                message: "Created Ad successfully",
                modaltitle: "Add New Advertisement",
                modalFields: CONSTANTS.FORM_FIELD.AD_MODAL,
                // payloadModifier: (res) => res,
              }}
            />
          </Row>
        </Card>
      </div>
    </>
  );
};

export default Advertisement;
